import {StrictMode} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import './style/default.css';
import App from './components/App'

// This is the ID of the div in your index.html file

const rootElement = document.getElementById('root');
const app = <StrictMode><App /></StrictMode>;
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

